import { useMutation } from "@tanstack/react-query";
import { demoteAuthUser } from "@/api/v1-jwt/tenancy/tenancy";
import { useAuth } from "@/providers/auth";

export function useDemoteAuthUser() {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  return useMutation({
    mutationFn: async ({ userId }) => demoteAuthUser({ clientId: id, userId }),
  });
}
